import { serialize, CookieSerializeOptions } from 'cookie';
import { IncomingMessage, ServerResponse } from 'http';
import { NextApiResponse } from 'next';

export const getCookie = (cname: string) => {
  const name = `${cname}=`;
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return null;
};

export const getCookieByName = (
  name_part_one: string,
  name_part_two: string,
) => {
  const match = document.cookie.match(
    new RegExp('(| )' + name_part_one + '([^;]+)' + name_part_two + '=([^;]+)'),
  );
  let cookieName = '';
  if (match && match[0]) {
    cookieName = match[0].split('=')[0].trim();
  }
  return cookieName;
};

/**
 * This sets cookies using the NextApiResponse object.
 */
export const setCookie = (
  res: NextApiResponse | ServerResponse<IncomingMessage>,
  name: string,
  value: unknown,
  options: CookieSerializeOptions = {},
) => {
  const stringValue =
    typeof value === 'object' ? 'j:' + JSON.stringify(value) : String(value);

  if (typeof options.maxAge === 'number') {
    options.expires = new Date(Date.now() + options.maxAge * 1000);
  }

  res.setHeader('Set-Cookie', serialize(name, stringValue, options));
};
